<template>
	<div class="game-overview">
		<div class="game-overview__body">
			<span
				v-if="game.topPerformer"
				class="game-overview__top-performer fonticon fonticon--star--fill"
			/>
			<div class="game-overview__image-wrapper">
				<img
					v-if="game.assets.thumbnail && game.assets.thumbnail.length > 0"
					:src="game.assets.thumbnail[0].link"
					:alt="game.gameName"
					class="game-overview__image"
				/>
			</div>
			<mq-layout v-if="$root.$data.user && $root.userHasPermission({
				'igt': ['AM', 'CM', 'SA'],
				'operator': ['affiliate', 'customer', 'performance'],
				'guest': ['guest'],
			})" :mq="['ltab', 'desk']" class="game-overview__meta-wrapper">
				<div class="game-overview__meta">
					<div class="grid grid--b5 grid--auto grid--nowrap grid--bottom">
						<div class="grid__item grid__item--space">
							<div class="h5 lato-bold game-overview__title">
								{{ game.gameName }}
							</div>
							<div
								v-if="description"
								v-html="description"
								class="game-overview__description"
							/>
						</div>
						<div class="grid__item">
							<span class="game-overview__action fonticon fonticon--plus--circle fs--40"/>
						</div>
					</div>
				</div>
			</mq-layout>
		</div>
	</div>
</template>

<script>

export default {
	name: 'GameOverview',
	props: {
		game: Object,
		description: String
	}
}
</script>

<style lang="scss">
@import "src/scss/toolkit";

$c: ".game-overview";
#{$c} {
	border-radius: 4px;

	&__body {
		position: relative;
		border-radius: 4px;
		overflow: hidden;
	}

	&__top-performer {
		position: absolute;
		display: block;
		color: palette('yellow');
		font-size: rem(22);
		top: 0px;
		right: 0px;
		padding: 5px 5px 20px 20px;
		z-index: 5;
		overflow: hidden;

		&:after {
			content: '';
			display: block;
			width: 80px;
			height: 80px;
			background-color: transparentize(palette('font', base, true), 0.5);
			position: absolute;
			top: 0px;
			right: 0px;
			transform: translateX(50%) translateY(-50%);
			z-index: -1;
			border-radius: 50%;
		}
	}

	&__image-wrapper {
		position: relative;
		overflow: hidden;
		display: block;
		text-align: center;

		> *, &:before {
			display: inline-block;
			vertical-align: middle;
		}

		&:before {
			position: relative;
			z-index: 1;
			content: "";
			width: 100%;
			padding-top: 100% * (217/300);
		}
	}

	&__image {
		position: absolute;
		top: 50%;
		left: 50%;
		min-width: 100%;
		min-height: 100%;
		transform: translateX(-50%) translateY(-50%);
	}

	&__meta-wrapper {
		@include extend(absolute-fill);
		opacity: 0;
		overflow: hidden;
		background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75));

		@include css-variables {
			transition: opacity calc(1s * #{var(base-trans-speed)});
		}

		#{$c}:hover & {
			opacity: 1;
		}
	}

	&__meta {
		position: absolute;
		z-index: 2;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: rem(24);
		transform: translateY(100%);
		color: palette(white);
		line-height: 1.1;

		@include css-variables {
			transition: transform calc(1s * #{var(base-trans-speed)});
		}

		#{$c}:hover & {
			transform: translateY(0%);
		}
	}

	&__title {
		margin-bottom: rem(8);
		line-height: inherit;
	}

	&__description {
		@include extend(heading-font);
	}
}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameOverview.vue